<template>
  <div>
    <PdfVentaDirecta2021 v-if="isPdfVentaDirecta2021" />
    <PdfVentaDirecta2022 v-else-if="isPdfVentaDirecta2022" />
    <PdfVentaDirecta2023 v-else-if="isPdfVentaDirecta2023" />
    <PdfVentaDirecta2024 v-else-if="isPdfVentaDirecta2024" />
    <PdfVentaDirecta2025 v-else-if="isPdfVentaDirecta2025" />
    <PdfVentaDirecta2026 v-else-if="isPdfVentaDirecta2026" />
    <PdfVentaDirecta2026V2 v-else-if="isPdfVentaDirecta2026V2" />
    <PdfVentaDirecta2025Pt v-else-if="isPdfVentaDirecta2025Pt" />
    <PdfVentaDirecta2025PtNexus v-else-if="isPdfVentaDirecta2025PtNexus" />
    <PdfVentaDirecta2026PtNexus v-else-if="isPdfVentaDirecta2026PtNexus" />
    <PdfBrokerConRecogida v-else-if="isPdfBrokerConRecogida" />
    <PdfBrokerSinRecogida v-else-if="isPdfBrokerSinRecogida" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CONTRACT_MODEL } from '@/helpers/constants'
import { GET_CONTRACT_MODEL } from '@/store/modules/offer/getters'

export default {
  name: 'PdfContent',
  components: {
    PdfVentaDirecta2021: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2021'),
    PdfVentaDirecta2022: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2022'),
    PdfVentaDirecta2023: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2023'),
    PdfVentaDirecta2024: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2024'),
    PdfVentaDirecta2025: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2025'),
    PdfVentaDirecta2026: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2026'),
    PdfVentaDirecta2026V2: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2026-v2'),
    PdfVentaDirecta2025Pt: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt'),
    PdfVentaDirecta2025PtNexus: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus'),
    PdfVentaDirecta2026PtNexus: () => import('@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus'),
    PdfBrokerConRecogida: () => import('@/containers/offer-form/sign-off/pdf-broker-con-recogida'),
    PdfBrokerSinRecogida: () => import('@/containers/offer-form/sign-off/pdf-broker-sin-recogida'),
  },
  computed: {
    ...mapGetters('offer', { contractModel: GET_CONTRACT_MODEL }),
    isPdfVentaDirecta2021() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2021
    },
    isPdfVentaDirecta2022() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2022
    },
    isPdfVentaDirecta2023() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2023
    },
    isPdfVentaDirecta2024() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2024
    },
    isPdfVentaDirecta2025() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025
    },
    isPdfVentaDirecta2026() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026
    },
    isPdfVentaDirecta2026V2() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_V2
    },
    isPdfVentaDirecta2025Pt() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT
    },
    isPdfVentaDirecta2025PtNexus() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2025_PT_NEXUS
    },
    isPdfVentaDirecta2026PtNexus() {
      return this.contractModel === CONTRACT_MODEL.PDF_VENTA_DIRECTA_2026_PT_NEXUS
    },
    isPdfBrokerConRecogida() {
      return this.contractModel === CONTRACT_MODEL.PDF_BROKER_CON_RECOGIDA
    },
    isPdfBrokerSinRecogida() {
      return this.contractModel === CONTRACT_MODEL.PDF_BROKER_SIN_RECOGIDA
    },
  },
}
</script>
